import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import moment from "moment"
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils"

export const bookingList = createAsyncThunk('booking/list', async ({ pageable: data, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + 'slot_booking',
            params: {
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
                'premise_id': data?.premise_id,
                'amenity_resource_id': data?.amenity_resource_id,
                'status': data?.status,
                'booking_date': data?.date
                    ? (moment(data.date, 'YYYY-MM-DD', true).isValid()
                        ? data.date
                        : moment(data.date, 'DD/MM/YYYY').format('YYYY-MM-DD'))
                    : undefined,
                'type': data?.type,
                'fDate': data?.fDate || undefined,
                'tDate': data?.tDate || undefined,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const slotBooking = createAsyncThunk('booking/slotBooking', async (data) => {
    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'slot_booking',
            data: {
                "premise_id": data?.values?.premise_id,
                "amenity_resource_id": data?.values?.amenity_resource_id,
                "slot_id": data?.values?.slot_id,
                "booking_date": data?.values?.booking_date,
                "guest_count": data?.values?.guest_count,
                "is_public": data?.values?.is_public,
                "is_private": data?.values?.is_private,
                "description": data?.values?.description,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const updateBookingStatus = createAsyncThunk('booking/updateStatus', async (data) => {
    try {
        const res = await axios({
            method: 'PUT',
            url: getConfig.API_URL + 'slot_booking',
            data: {
                "slot_booking_id": data?.slot_booking_id,
                "status": data?.status,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const booking = createSlice({
    name: 'booking',
    initialState: {
        list: [],
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(bookingList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.list = action.payload.data.data
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate)
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.list = []
            }
        })
    }
})

export default booking.reducer;